import { apiGet } from './client'
import type { ApiResponse } from '@crm/shared'

export interface AttachmentSettingsRow {
  id: string
  object_id: string
  record_id: string
  file_name: string
  file_size: number
  content_type: string
  uploaded_by: string
  uploaded_by_name: string
  created_at: string
  object_label: string
  object_name: string
}

export async function fetchAllAttachments(params?: { cursor?: string; limit?: number; object_id?: string }) {
  const searchParams = new URLSearchParams()
  if (params?.cursor) searchParams.set('cursor', params.cursor)
  if (params?.limit) searchParams.set('limit', String(params.limit))
  if (params?.object_id) searchParams.set('object_id', params.object_id)
  const qs = searchParams.toString()
  return apiGet<ApiResponse<AttachmentSettingsRow[]> & { pagination: { next_cursor: string | null; has_more: boolean } }>(
    `/settings/attachments${qs ? `?${qs}` : ''}`,
  )
}
